import { createSlice } from "@reduxjs/toolkit";
import { removeFromStorage, STORAGE_KEYS } from "../helpers";

const initialState = {
  user: null,
  token: null,
  tempToken: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth: (state) => {
      removeFromStorage(STORAGE_KEYS.token);
      state.user = null;
      state.token = null;
    },
    setCredentials: (state, action) => {
      state.user = action.payload.user ? action.payload.user : null;
      state.token = action.payload.token ? action.payload.token : null;
    },
    temporaryToken: (state, action) => {
      state.tempToken = action.payload.tempToken;
    },
  },
});

export const { resetAuth, setCredentials, temporaryToken } = authSlice.actions;

// Selectors
export const getCurrentUser = (state) => state.auth.user;
export const getToken = (state) => state.auth.token;
export const getTempToken = (state) => state.auth.tempToken;

export default authSlice.reducer;
